import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import useUserContext from '../hooks/use-user-context';
import {
  createOptionMap,
  isBrowser,
  isVisitorBot,
  replaceWithComponent
} from '../utilities/misc';
import { rem } from '../utilities/style';
import { absolutizeCDNUrls, convertPdfCDNUrls } from '../utilities/url';
import { colors } from '../theme/colors';
import { media } from '../theme/media';

import Button from './buttons/Button';
import { headers } from '../styles/type';

const Container = styled.div`
`;

const Content = styled.div`
  text-align: center;
`;

const Object = styled.object`
  width: 100%;
  aspect-ratio: 8.5 / 11;
  max-height: calc(100vh - ${rem(56 + 20)});

  ${media('>small')} {
    max-height: calc(100vh - ${rem(70 + 20)});
  }

  ${media('>nav')} {
    max-height: calc(100vh - ${rem(90 + 20)});
  }
`;

const Description = styled.div`
  margin: ${rem(50)} 0;

  h2 {
    ${headers.h5}
  }
`;

const DescriptionTitle = styled.h2`
  margin: 0 0 ${rem(15)};
`;

const DescriptionText = styled.div`
  color: ${colors.gray['600']};
`;

const Newline = () => <br />;

const PdfEmbed = ({ url, description }) => {
  const data = useStaticQuery(graphql`
    query PdfEmbed {
      allContentfulOptionSet(filter: {name: {eq: "globals"}}) {
        nodes {
          ...OptionSetFragment
        }
      }
    }
  `);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const downloadButtonText = options['globals.pdf_embed_download_button_text'];
  const descriptionTitle = options['globals.pdf_embed_description_title'];
  const isIos = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isBot = isVisitorBot();
  const showFallbackButton = isBrowser && (isIos || isBot);
  let formattedUrl = absolutizeCDNUrls(url);
  formattedUrl = convertPdfCDNUrls(formattedUrl, language);

  return (
    <Container itemScope itemType="https://schema.org/DigitalDocument">
      <link itemProp="url" href={formattedUrl} />
      <Content>
        {showFallbackButton ? (
          <Button to={formattedUrl}>
            {downloadButtonText}
          </Button>
        ) : (
          <Object data={formattedUrl} type="application/pdf" title="lsdkjftest">
            <Button to={formattedUrl}>
              {downloadButtonText}
            </Button>
          </Object>
        )}
      </Content>
      {description && (
        <Description>
          <DescriptionTitle>
            {descriptionTitle}
          </DescriptionTitle>
          <DescriptionText itemProp="text">
            {replaceWithComponent(/(\n)/g, description, Newline)}
          </DescriptionText>
        </Description>
      )}
    </Container>
  );
};

PdfEmbed.propTypes = {
  url: PropTypes.string.isRequired,
  description: PropTypes.string
};

export default PdfEmbed;
